import React, {useEffect, useMemo, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

const MotherFollowupConditionsStep: React.FC<StepComponentProps> = ({
                                                                      formData,
                                                                      updateFormData,
                                                                      onNext,
                                                                      onPrevious,
                                                                      canGoBack,
                                                                      canGoNext,
                                                                      patientCaseType,
                                                                      journey,
                                                                      motherFollowupData,
                                                                      motherConditionsData,
                                                                    }) => {
  const [selectedCondition, setSelectedCondition] = useState<string | null>(formData.motherFollowupCondition);

  const patientCountryId = journey.patientCase?.patient?.countryId;
  const isAntepartum = journey.patientCase?.emergencyType === EmergencyType.ANTEPARTUM;

  // Filter conditions for mother - use real conditions data
  const motherFollowupConditions = useMemo(() => {
    return motherConditionsData?.filter(condition => {
      const baseConditions = (
        condition.isAlive === formData.motherAlive
      );

      // Only check isDelivered for antepartum cases
      if (isAntepartum) {
        return baseConditions && condition.isDelivered === formData.isDelivered;
      }

      return baseConditions;
    }) || [];
  }, [motherConditionsData, formData.motherAlive, formData.isDelivered, isAntepartum]);

  const displayConditions = motherFollowupConditions.length > 0 ? motherFollowupConditions : [];

  useEffect(() => {
    updateFormData({motherFollowupCondition: selectedCondition});
  }, [selectedCondition]);

  const handleConditionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedCondition(e.target.value);
  };

  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="text-primary mb-4">
          Select a mother <span className="text-danger">follow-up condition</span>
        </h6>
        <AvForm onValidSubmit={handleSubmit}>
          <AvRadioGroup
            name="motherFollowupCondition"
            required={displayConditions.length > 0}
            value={selectedCondition}
            className="form-control"
            style={{overflowY: 'auto', height: '400px'}}
          >
            <Row>
              {displayConditions.length === 0 ? (
                <Col md="12">
                  <div className="text-center py-4">
                    <div className="text-muted">No conditions available for this patient status.</div>
                  </div>
                </Col>
              ) : (
                displayConditions.map((condition) => (
                  <Col md="12" key={condition.id}>
                    <AvRadio
                      name="motherFollowupCondition"
                      value={condition.id}
                      onChange={handleConditionChange}
                      label={condition.enFollowup}
                    />
                  </Col>
                ))
              )}
            </Row>
          </AvRadioGroup>

          <FollowupButtons
            currentStep={6}
            totalSteps={10}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default MotherFollowupConditionsStep;
